import type { IManagementReportDataset } from '@commenda/api';

import { ReportContext } from '../context/ReportContext';
import { useReportState } from '../hooks/useReportState';
import type { MonthKey } from '../types/period';

interface IReportProviderProps {
  dataset: IManagementReportDataset;
  currency: string;
  booksClosedThrough: MonthKey;
  columnLayout: boolean;
  inlineOverride: boolean;
  children: React.ReactNode;
}

export const ReportProvider = ({
  dataset,
  currency,
  booksClosedThrough,
  columnLayout,
  inlineOverride,
  children,
}: IReportProviderProps) => {
  const value = useReportState({
    dataset,
    currency,
    booksClosedThrough,
    columnLayout,
    inlineOverride,
  });
  return (
    <ReportContext.Provider value={value}>{children}</ReportContext.Provider>
  );
};
